define(function(require,exports,module){
    /**
     * @获取用户信息并更新在顶栏个人信息
     */
    var setUserInfo = function(options){
        options = $.extend({
            el: $("#new-ttbar-login"),
            callback: null
        }, options || {});

        var getHttp = function(){
            return 'https:' == document.location.protocol ? 'https://' : 'http://';
        };

        $.ajax({
            url: getHttp() + "passport.jd.com/new/helloService.ashx", //接口人:穆永俊
            dataType: "jsonp",
            scriptCharset: "GBK",
            success: function (data) {
                if ( !data ) {
                    return false;
                }

                //更新顶栏个人信息
                if ( data.info ) {
                    var infoHk = data.info;
                    if(data.info.indexOf("jd.com") > -1) {
                        infoHk = data.info.replace(/home.jd.com/g, "home.jd.hk");
                    }
                    // 用全球购sso更换base中的login方法
                    if (data.info.indexOf('login()') > -1) {
                        infoHk = data.info.replace(/login\(\)/g, "newLogin()");
                    }
                    options.el.html(infoHk);
                }
                var callback = function () {
                    clearTimeout(timer);
                    if ( $.isFunction(options.callback) ) {
                        options.callback(data);
                    }
                    // 执行完一次后清空
                    callback = $.noop;
                };
                // 防止sso 有链接异常，造成callback不执行
                var timer = setTimeout(function(){
                    callback();
                }, 2000);

                //更新其它域名cookies
                if ( data.sso ) {
                    var len = data.sso.length;
                    $.each(data.sso, function (i, k) {
                        $.getJSON(k).complete(function(){
                            if ( --len == 0 ) {
                                callback();
                            }
                        });
                    });
                } else {
                    callback();
                }
            }
        });
    };

    module.exports = setUserInfo;
});


// WEBPACK FOOTER //
// ./src/js/unit/setUserInfo/setUserInfo.js